import React, { useState } from 'react'
import classnames from 'classnames/bind'
import {
  Accordion,
  Icon,
  List,
  Text,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
// @ts-ignore no types
import styles from './styles.scss'
const cx = classnames.bind(styles)

interface SectionPanelProps {
  compact?: boolean | 'top-only'
  elmId: string
  highlighted?: boolean
  collapsible?: boolean
  title?: string
  subtitle?: string
  style?: React.CSSProperties
  children: React.ReactNode
}

const SectionPanel = ({
  compact,
  elmId,
  highlighted = false,
  collapsible = true,
  title = '',
  subtitle = '',
  style = {},
  children,
}: SectionPanelProps) => {
  const isMobile = hooks.useIsMobileHook()
  const [isContentVisible, setIsContentVisible] = useState(true)

  const toggleContentVisibity = () => {
    setIsContentVisible(prevState => !prevState)
  }

  const renderTitle = () => {
    const titleLevel = isMobile ? 3 : 2
    return (
      (!!title || !!subtitle) && (
        <Accordion.Title
          active={isContentVisible}
          data-elm-id={`${elmId}_accordion_toggle`}
          className={cx('default-cursor')}
        >
          {collapsible && (
            <Icon
              color='grayMedium'
              className={cx('toggle-icon', 'pointer-cursor')}
              name={isContentVisible ? 'minus-circle' : 'plus-circle'}
              iconStyle='light'
              size='big'
              onClick={toggleContentVisibity}
            />
          )}
          <Text.Header
            compact
            level={titleLevel}
            // @ts-ignore fix types in DS, export enum if possible
            weight='medium'
            data-elm-id={`${elmId}_title`}
          >
            {title}
            {!!title && !!subtitle && ' '}
            <Text.Header
              level={2}
              color='grayMedium'
              // @ts-ignore fix types in DS, export enum if possible
              weight='medium'
              as='span'
            >
              {subtitle}
            </Text.Header>
          </Text.Header>
        </Accordion.Title>
      )
    )
  }

  return (
    <section
      style={style}
      className={cx(
        'section',
        { compact },
        { 'compact-top-only': compact === 'top-only' },
        { highlighted },
        { 'collapsible-title': collapsible && title },
        {
          'expanded-mobile':
            collapsible && title && isContentVisible && isMobile,
        }
      )}
    >
      <div id={elmId} className={cx('nav-anchor')} />
      <div className={cx('container')} data-elm-id={elmId}>
        <Accordion fluid role='list'>
          <List.Item>
            {renderTitle()}
            <Accordion.Content
              active={isContentVisible}
              content={children}
              className={cx({ 'clear-overflow': !collapsible })} // This prevents dropdowns from breaking on non-collapsible elements
              data-elm-id={`${elmId}_content`}
            />
          </List.Item>
        </Accordion>
      </div>
    </section>
  )
}

export default SectionPanel
